import type { ExperimentProduct } from '@forest/paywall-core'
import type { SubscriptionProduct } from './types'

const TTL_MS = 60 * 60 * 1000 // 1 hour

interface CacheEnvelope<T> {
  data: T
  timestamp: number
}

function readCached<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw) as CacheEnvelope<T>
    if (Date.now() - parsed.timestamp > TTL_MS) {
      localStorage.removeItem(key)
      return null
    }
    return parsed.data
  } catch (error) {
    console.error('Error reading cache from localStorage:', error)
    localStorage.removeItem(key)
    return null
  }
}

function writeCached<T>(key: string, data: T): void {
  const envelope: CacheEnvelope<T> = { data, timestamp: Date.now() }
  localStorage.setItem(key, JSON.stringify(envelope))
}

export function readSubscriptionProductsCache(
  key: string,
): SubscriptionProduct[] | null {
  return readCached<SubscriptionProduct[]>(key)
}

export function writeSubscriptionProductsCache(
  key: string,
  value: SubscriptionProduct[],
): void {
  writeCached(key, value)
}

export function readExpSkusCache(key: string): ExperimentProduct[] | null {
  return readCached<ExperimentProduct[]>(key)
}

export function writeExpSkusCache(
  key: string,
  value: ExperimentProduct[],
): void {
  writeCached(key, value)
}
